import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

if (window.REACT_APP_PUBLIC_API_URL) {
    localStorage.setItem('publicApiUrl', window.REACT_APP_PUBLIC_API_URL);
} else {
    window.REACT_APP_PUBLIC_API_URL = localStorage.getItem('publicApiUrl');
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// Remove existing service worker, NB! Can be removed afterwards
if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function unRegisterAll(registrations) {
        for (const registration of registrations) {
            registration.unregister();
        }
    });
}
